import { Dispatch, SetStateAction } from 'react';
import { FormInstance, Space } from 'antd';

import { DeleteAction, SaveAction, UndoAction } from 'components';

import { handleDeleteAddedRow, handleSaveRow, handleUndoRow } from './lib';

interface ICRUDTableEditingActions<T> {
  form: FormInstance<T>;
  disabled: boolean;
  recordKey: number;
  editableTableData: T[];
  setEditingKey: (key?: number) => void;
  setIsFormValid: (status: boolean) => void;
  onPostTableData?: (data: T) => void;
  onPatchTableData?: (data: T) => void;
  setEditableTableData: Dispatch<SetStateAction<T[] | undefined>>;
}

export const CRUDTableEditingActions = <T extends Record<string, unknown>, >({
  form,
  disabled,
  recordKey,
  editableTableData,
  setEditingKey,
  setIsFormValid,
  onPostTableData,
  onPatchTableData,
  setEditableTableData,
}: ICRUDTableEditingActions<T>) => (
  <Space.Compact>
    <SaveAction
      disabled={disabled}
      onConfirm={handleSaveRow({
        form,
        recordKey,
        editableTableData,
        setEditingKey,
        onPostTableData,
        onPatchTableData,
        setEditableTableData,
      })}
    />

    {recordKey !== 0 && (
      <UndoAction
        onConfirm={handleUndoRow({
          form,
          setEditingKey,
          setIsFormValid,
        })}
      />
    )}

    {recordKey === 0 && (
      <DeleteAction
        onConfirm={handleDeleteAddedRow({
          form,
          recordKey,
          setEditingKey,
          setIsFormValid,
          setEditableTableData,
        })}
      />
    )}
  </Space.Compact>
);
